export default { 
  display: 'inline-block',
  width: 36, 
  height: 36 
}